import {AUTH_LOGOUT,AUTH_ERROR,AUTH_REQUEST,AUTH_SUCCESS} from "../actions/auth";
import {USER_REQUEST} from "../actions/user";
import apiCall, {ApiDefaults} from "@/utils/api_call";
import MD5 from 'crypto-js/md5';

const state = { token : localStorage.getItem('user-token') || '', status : '', hasLoadedOnce : false };

const getters = {
	isAuthenticated : state => !! state.token,
	authStatus : state => state.status,
};

const actions = {
	[AUTH_REQUEST] : ( { commit, dispatch }, user ) => {
		return new Promise( (resolve, reject) => {
			commit( AUTH_REQUEST );

			var postData = new URLSearchParams();
			postData.append( 'user', user.username);
			postData.append( 'password', user.password);
			let apiParams = Object.assign({},ApiDefaults,
				{ method: 'post',params:{ id : 1}, data : postData }	);
			apiCall( apiParams )
				.then((response) => {

					if ( response.data.hasOwnProperty('loginStatus' ) && response.data.loginStatus ) {

						let token = '';
						// console.dir( response.headers )
						/** ToDo: [] generierten token durch cookie ersetzen */
						if( response.headers.hasOwnProperty('Set-Cookie') ) {
							token = response.headers['Set-Cookie'];
						}
						else {
							token = MD5( JSON.stringify(response.data.loggedInUser) ).toString();
						}

						let commitData = response.data.loggedInUser;

						if( commitData.image === null ) {
                            commitData.image = require('@/assets/images/icons/ic_profil.svg');
                        }

						commitData.token = token;
						localStorage.setItem( 'user-token', token );

						localStorage.setItem( 'tmp-profile', JSON.stringify( commitData ) );

						commit(AUTH_SUCCESS, commitData);
						dispatch(USER_REQUEST);
						resolve(response.data);
					}
					else {
						commit(AUTH_ERROR);
						let err = new Error('Anmelde Daten waren nicht korrekt.');
						reject( err );
					}
				})
				.catch((err) => {
					// console.log( 'AUTH_ERROR: ', err );
					commit(AUTH_ERROR);
					reject(new Error( err.msg ));
				});

		});
	},
	[AUTH_LOGOUT] : ({commit,dispatch}) => {
		return new Promise( (resolve, dispatch) => {
			commit(AUTH_LOGOUT);
			let token = localStorage.getItem( 'user-token' );

			let apiParams = Object.assign(	ApiDefaults,
				{ method: 'post', params:{ route : '/logout', token : token }}	);
			apiCall( apiParams )
				.then( (response) => {
					if (response.status === 200 ) {
						localStorage.removeItem('user-token');
						localStorage.removeItem('tmp-profile');
						localStorage.removeItem('tmp-profile');
						resolve();
					}
				})
				.catch( (err) => {
					console.log( err );
				} );
		});
	},
	[AUTH_ERROR] : ({commit,dispatch}) => {

	}
};

const mutations = {
	[AUTH_REQUEST]: (state) => {
		state.status = 'loading'
	},
	[AUTH_SUCCESS]: (state, resp) => {
		state.status = 'success';
		state.token = resp.token;
		state.hasLoadedOnce = true;
	},
	[AUTH_ERROR]: (state) => {
		state.status = 'error';
		state.hasLoadedOnce = true;
	},
	[AUTH_LOGOUT]: (state) => {
		state.token = '';
	}
};

export default {
	state,
	getters,
	actions,
	mutations
}



// WEBPACK FOOTER //
// ./src/utils/store/modules/auth.js